// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"374":"a8eeb2db","428":"abbe779b","637":"0bff0504","646":"c571201e","819":"5730f1bc"}[chunkId] + ".chunk.js";
};